import { InteriorsIcon } from 'components/ProductSidebar/ProductGroupNav/ProductGroupNavSVGs';
import { ConfigOptions, ProductGroup } from 'rangeConfig/@types';
import selectedMenu from './selectedMenu';
import mainMenu from './mainMenu';
import { ProductType } from '@inter-ikea-storageone/range';

const interiors = (options?: ConfigOptions): ProductGroup => {
  return {
    id: 'interiors',
    productTypes: [
      ProductType.PAX_CLOTH_RAIL_350,
      ProductType.PAX_CLOTH_RAIL_580,
      ProductType.PAX_SHELF,
      ProductType.PAX_GLASS_SHELF,
      ProductType.PAX_PULL_OUT_TRAY,
      ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
      ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
      ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM,
      ProductType.PAX_PULL_OUT_TROUSER_HANGER,
      ProductType.PAX_DRAWER,
      ProductType.PAX_GLASS_DRAWER,
      ProductType.PAX_DRAWER_FRAMED,
      ProductType.PAX_DRAWER_FRAMED_GLASS,
      ProductType.PAX_DRAWER_LOCKABLE,
      ProductType.PAX_MESH_BASKET_ASM,
      ProductType.PAX_METAL_BASKET_ASM,
      ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM,
      ProductType.PAX_SHOE_SHELF,
      ProductType.PAX_PULL_OUT_SHOE_SHELF,
      ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
      ProductType.PAX_VALET_HANGER,
      ProductType.PAX_L_DIVIDER,
      ProductType.PAX_T_DIVIDER,
      ProductType.PAX_CLEANING_INTERIOR
    ],
    icon: InteriorsIcon,

    mainMenu: mainMenu(options),
    selectedMenu: selectedMenu()
  };
};

export default interiors;
